<template>
  <b-form-group
    :label="$t('fields.title')"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      :name="$t('fields.title')"
      vid="title"
      rules="required|min:3"
    >
      <b-form-input
        id="title"
        v-model="dataItem.title"
        :placeholder="$t('guides.form.titlePlaceholder')"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'GuidesTitleCard',
  components: { BFormGroup, BFormInput, ValidationProvider },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['guides/dataItem']
    },
  },
}
</script>
